"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('updateNotificationIgnore')(function updateNotificationIgnore(notification, ignore) {
    notification.ignore = ignore;
});
//# sourceMappingURL=updateNotificationIgnore.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-header-toast-notification/lib/actions/updateNotificationIgnore.js
// module id = 1617
// module chunks = 3 14 105 106 107